import {
  REQUEST_UNIT_REPORT,
  RESPONSE_UNIT_REPORT,
  REQUEST_UNIT_REPORT_FAILURE,
  RESPONSE_CANCEL_UNIT_REPORT,
  CLEAR_UNIT_REPORT,
} from "../actions/unitReportActions";
import { cancelRequest } from "../shared/services/cancelRequest.service";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: { units: [], pivot:[] },
  errors: [],
  isCanceled: false,
  cancel: cancelRequest(),
};

const unitReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_UNIT_REPORT:
      return Object.assign({}, state, {
        isCanceled: false,
        dataState: states.REQUEST,
        data: { units: [] , pivot:[]},
      });
    case RESPONSE_UNIT_REPORT:
      return Object.assign({}, state, {
        dataState: states.READY,
        data: action.data,
      });
    case REQUEST_UNIT_REPORT_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case RESPONSE_CANCEL_UNIT_REPORT:
      return Object.assign({}, state, {
        isCanceled: true,
        cancel: cancelRequest(),
      });
    case CLEAR_UNIT_REPORT:
      return Object.assign({}, state, {
        dataState: states.NOT_REQUESTED,
        data: { units: [], pivot:[] },
        errors: [],
        isCanceled: false,
      });
    default:
      return state;
  }
};

export default unitReportReducer;
